var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8152 7.63942H18.05V7.6H9.5V11.4H14.8689C14.0857 13.6121 11.9809 15.2 9.5 15.2C6.35217 15.2 3.8 12.6478 3.8 9.5C3.8 6.35217 6.35217 3.8 9.5 3.8C10.953 3.8 12.275 4.34815 13.2815 5.24352L15.9685 2.55645C14.2718 0.975175 12.0023 0 9.5 0C4.25362 0 0 4.25362 0 9.5C0 14.7464 4.25362 19 9.5 19C14.7464 19 19 14.7464 19 9.5C19 8.86302 18.9345 8.24125 18.8152 7.63942Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09473 5.07823L4.21595 7.36725C5.0605 5.2763 7.10585 3.8 9.49938 3.8C10.9524 3.8 12.2743 4.34815 13.2809 5.24353L15.9679 2.55645C14.2712 0.975175 12.0017 0 9.49938 0C5.85043 0 2.68598 2.06008 1.09473 5.07823Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50034 18.9999C11.9542 18.9999 14.1838 18.0608 15.8696 16.5337L12.9294 14.0457C11.9756 14.7681 10.79 15.1999 9.50034 15.1999C7.02939 15.1999 4.93132 13.6243 4.14092 11.4256L1.04297 13.8124C2.61522 16.889 5.80817 18.9999 9.50034 18.9999Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8152 7.63964H18.05V7.60022H9.5V11.4002H14.8689C14.4927 12.4628 13.8092 13.3791 12.9276 14.0464C12.9281 14.046 12.9286 14.046 12.929 14.0455L15.8693 16.5335C15.6612 16.7226 19 14.2502 19 9.50022C19 8.86324 18.9345 8.24147 18.8152 7.63964Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.96e31d48451be71ec53a3ffcd2c8d0a8.svg";
export { ForwardRef as ReactComponent };